/**
 * @fileoverview GET handler for the "/engagement/api/segment_cohorts/tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementApiSegmentCohortsTags } from "./constants";
import type { GetEngagementApiSegmentCohortsTagsResult } from "./types";
import { isGetEngagementApiSegmentCohortsTagsResult } from "./validators";

export const getEngagementApiSegmentCohortsTags = reactQueryFetcherAdapter(
  engagementApiSegmentCohortsTags,
  (signal: AbortSignal): Promise<GetEngagementApiSegmentCohortsTagsResult> => {
    return fetch(engagementApiSegmentCohortsTags, "GET", undefined, { signal });
  },
  isGetEngagementApiSegmentCohortsTagsResult
);
